import configureStore from "./configureStore";

const store = configureStore();

/**
 * The redux store.
 */
export default store;
